var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgSimpleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4417 8.2894L27.3518 8.37931L18.9733 16.7578L10.5948 8.37851L10.5049 8.28863L12.9828 5.81067L13.0727 5.90056L17.2208 10.0486V1.7525L18.9733 0L20.7258 1.7525V10.0486L24.8738 5.90056L24.9637 5.81067L27.4417 8.2894Z",
    fill: "#00CDAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4417 29.6578L24.9637 32.1358L24.8738 32.0459L20.7258 27.8992V36.194L18.9733 37.9465L17.2208 36.194V27.8992L13.0727 32.0459L12.9828 32.1358L10.5049 29.6578L18.9735 21.1895L27.4417 29.6578Z",
    fill: "#2575F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1935 20.726H27.8987L32.0454 24.8741L32.1353 24.964L29.6574 27.4419L29.5675 27.352L21.189 18.9735L29.6574 10.5051L32.1353 12.9831L32.0454 13.073L27.8987 17.2211H36.1935L37.946 18.9735L36.1935 20.726Z",
    fill: "#2575F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7572 18.9735L8.37871 27.352L8.28881 27.4419L5.81087 24.964L5.90075 24.8741L10.0474 20.726H1.75249L0 18.9735L1.75249 17.2211H10.0464L5.89976 13.073L5.80988 12.9831L8.28783 10.5051L16.7572 18.9735Z",
    fill: "#2575F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSimpleLogo);
export default __webpack_public_path__ + "static/media/img_simple_logo.03731576e9e8ec512b06640bbea89891.svg";
export { ForwardRef as ReactComponent };